// Sound Manager
// Overriding the soundManager

soundManager = {};
soundManager.timeMultiplier = 1;
soundManager.endedCallbacks = {};
soundManager.playingSounds = [];
soundManager.allSounds = [];
soundManager.delayedStop = [];
soundManager._mute = false;
soundManager._forceMute = false;

soundManager.musicVolume = 1;
soundManager.effectVolume = 1;

soundManager.musicList = [];
soundManager.effectList = [];

// ----------------
// COMMON
// ----------------
soundManager.checkUnusedResources = function () {
  console.log("The following sounds have not yet been played");
  var tagNames = Object.keys(soundManager.soundsConfig.tags);
  for (var i = 0; i < tagNames.length; i++) {
    if (!soundManager.soundsConfig.tags[tagNames[i]].played) {
      console.log("- " + tagNames[i]);
    }
  }
};

soundManager.setMusicVolume = function (volume) {
  soundManager.musicVolume = volume;

  soundManager.musicList.forEach((index) => {
    let sound = soundManager.getSound(index.id);
    soundManager.setVolume(sound.volume, index.id);
  });
};

soundManager.getMusicVolume = function () {
  return soundManager.musicVolume;
};

soundManager.setEffectsVolume = function (volume) {
  soundManager.effectVolume = volume;

  soundManager.effectList.forEach((index) => {
    let sound = soundManager.getSound(index.id);
    soundManager.setVolume(sound.volume, index.id);
  });
};

soundManager.getEffectVolume = function () {
  return soundManager.effectVolume;
};

soundManager.play = function (name, endedCallback) {
  // If no sounds are available, callback straight away
  if (!soundManager.soundAvailable()) {
    if (endedCallback) {
      endedCallback();
    }

    return;
  }

  if (!soundManager.isSound(name)) {
    console.log("Cannot play sound " + name + " as it is not defined");

    if (endedCallback) {
      endedCallback();
    }
    return;
  }

  soundManager.soundsConfig.tags[name].played = true;

  var howlerID = soundManager.soundSprite.play(soundManager.soundsConfig.tags[name].filename);

  let vol = 1;

  if (typeof soundManager.soundsConfig.tags[name].volume !== "undefined") {
    vol = soundManager.soundsConfig.tags[name].volume;
  }

  let sound = soundManager.getSound(name);

  if (sound === undefined) {
    let list = soundManager.effectList;
    let type = "effect";

    if (soundManager.soundsConfig.tags[name].soundGroup === "music") {
      list = soundManager.musicList;
      type = "music";
    }

    sound = {
      id: howlerID,
      volume: vol,
      defaultVolume: vol,
      timer: undefined,
      type,
    };
    soundManager.allSounds.push(sound);

    list.push(sound);
  }

  soundManager.setVolume(vol, howlerID);

  soundManager.endedCallbacks[howlerID] = endedCallback;
  soundManager.soundSprite.rate(soundManager.timeMultiplier, howlerID);
  return howlerID;
};

soundManager.stop = function (name) {
  var filename = "";

  if (!soundManager.soundAvailable()) {
    return;
  }

  if (soundManager.isSound(name)) {
    filename = soundManager.soundsConfig.tags[name].filename;

    soundManager.getSound(filename, true);
  }

  // See if this sound / ID is playing
  for (var i = soundManager.soundSprite._sounds.length - 1; i >= 0; i--) {
    var playingSprite = soundManager.soundSprite._sounds[i];
    if (!playingSprite._ended) {
      if (playingSprite._sprite === filename || playingSprite._id === name) {
        if (soundManager.playingSounds.indexOf(playingSprite._id) === -1) {
          // A call was made to stop this sound, but it hasnt started yet. Delay the stop
          soundManager.delayedStop.push(playingSprite._id);
          //console.log(playingSprite._id + " delayed stop");
        } else {
          // We can stop this sound
          soundManager.soundSprite.stop(playingSprite._id);
          soundManager.onSoundEnd(playingSprite._id);
        }
      }
    }
  }
};

soundManager.setVolume = function (volume, id) {
  let sound = soundManager.getSound(id);

  if (sound) {
    let typeMultiplier = sound.type === "music" ? soundManager.musicVolume : soundManager.effectVolume;

    soundManager.soundSprite.volume(sound.defaultVolume * volume * typeMultiplier, id);

    if (sound) sound.volume = volume;
  }
};

soundManager.fade = async function (volume, time, id, onComplete, test = false) {
  soundManager.removeTimer(id);

  let sound = soundManager.getSound(id);

  let fadeObject = { volume: sound.volume };

  const timer = gsap.to(fadeObject, {
    duration: time,
    volume: volume,
    onUpdate: () => {
      soundManager.setVolume(fadeObject.volume, id);
    },
  });

  await timer;
  if (onComplete) {
    onComplete();
    soundManager.removeTimer(id);
  }

  sound.timer = timer;
};

soundManager.getSound = function (id, remove = false) {
  let sound = undefined;

  for (let i = 0; i < soundManager.allSounds.length; i++) {
    sound = soundManager.allSounds[i];

    if (sound.id === id) {
      if (remove) {
        soundManager.allSounds.splice(i, 1);
        break;
      } else {
        return sound;
      }
    }
  }

  if (remove && sound !== undefined) {
    let list = sound.type === "music" ? soundManager.musicList : soundManager.effectList;

    for (let i = 0; i < list.length; i++) {
      sound = list[i];

      if (sound.id === id) {
        list.splice(i, 1);
      }
    }
  }
};

soundManager.removeTimer = function (id) {
  for (let i = 0; i < soundManager.allSounds.length; i++) {
    let sound = soundManager.allSounds[i];

    if (sound.id === id) {
      if (sound.timer) sound.timer.kill();

      return;
    }
  }
};

soundManager.resumeAllSounds = function () {
  if (checkForUndefined(soundManager.soundSprite)) return;

  // Resume all sounds
  for (var i = 0; i < soundManager.soundSprite._sounds.length; i++) {
    if (!soundManager.soundSprite._sounds[i]._ended) {
      soundManager.soundSprite.play(soundManager.soundSprite._sounds[i]._id);
    }
  }
};

soundManager.pauseAllSounds = function () {
  if (checkForUndefined(soundManager.soundSprite)) return;

  // Pause all playing sounds
  for (var i = 0; i < soundManager.soundSprite._sounds.length; i++) {
    if (!soundManager.soundSprite._sounds[i]._ended) {
      soundManager.soundSprite.pause(soundManager.soundSprite._sounds[i]._id);
    }
  }
};

soundManager.mute = function (mute) {
  soundManager._mute = mute;
  Howler.mute(soundManager._mute || soundManager._forceMute);

  messageBus.postImmediate("audio:currentMuteState", {
    type: "audio:currentMuteState",
    muted: soundManager._mute,
  });
};
soundManager.forceMute = function (mute) {
  soundManager._forceMute = mute;
  Howler.mute(soundManager._mute || soundManager._forceMute);
};

// ----------------
// HELPER
// ----------------
soundManager.isAnySoundPlaying = function () {
  for (var i = 0; i < soundManager.soundSprite._sounds.length; i++) {
    if (!soundManager.soundSprite._sounds[i]._ended) {
      return true;
    }
  }

  return false;
};

soundManager.isSoundPlaying = function (name) {
  for (var i = 0; i < soundManager.soundSprite._sounds.length; i++) {
    if (soundManager.soundSprite._sounds[i]._sprite === name) {
      return !soundManager.soundSprite._sounds[i]._ended;
    }
  }

  return false;
};

soundManager.getSoundLength = function (id) {
  var tag = soundManager.soundsConfig.tags[id];
  var spriteDef = soundManager.soundSprite._sprite[tag.filename];
  return Math.floor(spriteDef[1]);
};

soundManager.isSound = function (name) {
  var soundDef = soundManager.soundsConfig.tags[name];
  if (checkForUndefined(soundDef)) return false;
  if (checkForUndefined(soundDef.filename)) return false;

  return checkForDefined(soundManager.soundSpriteDef.sprite[soundDef.filename]);
};

soundManager.soundAvailable = function () {
  return !Howler.noAudio && !soundManager._forceMute;
};

// ----------------
// LOADING
// ----------------
soundManager.loadConfig = function (configLoadedCallback) {
  // Load the configuration file that describes the sounds
  soundManager.configLoadedCallback = configLoadedCallback;
  ReflexLoader.loadFile("config/sounds.json", soundManager.generateConfig);
};

soundManager.generateConfig = function (filename, data) {
  soundManager.soundsConfig = JSON.parse(data);

  // Tell resource manager we only need to load one file!
  soundManager.configLoadedCallback(1);
};

// This is called by resource manager to load the sound sprite
soundManager.loadFiles = function (progressCallback, completeCallback) {
  // Store callbacks
  soundManager.progressCallback = progressCallback;
  soundManager.completeCallback = completeCallback;

  const isMobile = gdk.deviceInfo.mobile;
  const sp = gdk.getServerParser();
  const isReplay = sp.isReplayMode !== undefined ? sp.isReplayMode() : false;

  let audioNameToLoad = resourceManager.selectedAssetResolution.name;
  if (isMobile) {
    if (isReplay) {
      audioNameToLoad = "mobileReplay";
    } else {
      audioNameToLoad = "mobile";
    }
  }

  // First we need to load the sound sprite definition file
  ReflexLoader.loadFile(soundManager.soundsConfig.soundSprite[audioNameToLoad], soundManager.onSoundSpriteDefLoaded);
};

soundManager.onSoundSpriteDefLoaded = function (filename, data) {
  soundManager.soundSpriteDef = JSON.parse(data);

  // Check if this is a howler file, or a jukebox format
  if (checkForDefined(soundManager.soundSpriteDef.spritemap)) {
    // This is a Jukebox format file
    soundManager.soundSpriteDef.sprite = {};
    var keys = Object.keys(soundManager.soundSpriteDef.spritemap);
    for (var i = 0; i < keys.length; i++) {
      var soundDef = soundManager.soundSpriteDef.spritemap[keys[i]];
      soundManager.soundSpriteDef.sprite[keys[i]] = [];
      soundManager.soundSpriteDef.sprite[keys[i]].push(soundDef.start * 1000);
      soundManager.soundSpriteDef.sprite[keys[i]].push(soundDef.end * 1000 - soundDef.start * 1000);
      soundManager.soundSpriteDef.sprite[keys[i]].push(soundManager.isLooping(keys[i]));
    }

    soundManager.soundSpriteDef.urls = soundManager.soundSpriteDef.resources;
  } else if (checkForDefined(soundManager.soundSpriteDef.sprite)) {
    // This is a howler format file
    var keys = Object.keys(soundManager.soundSpriteDef.sprite);
    for (var i = 0; i < keys.length; i++) {
      var soundDef = soundManager.soundSpriteDef.sprite[keys[i]];
      soundDef.push(soundManager.isLooping(keys[i]));
    }
  } else {
    console.error("Unknown sound file format");
    return;
  }

  if (gdk.deviceInfo.ipad !== true && gdk.deviceInfo.iphone !== true) {
    soundManager.soundSpriteDef.urls.forEach(function (value, index, array) {
      if (value.slice(-3) === "ogg") {
        array.splice(index, 1);
        return;
      }
    });
  }
  // Add "sounds" subdirectory onto sound sprite
  for (i = 0; i < soundManager.soundSpriteDef.urls.length; i++) {
    soundManager.soundSpriteDef.urls[i] = gdk.ammendResourceName(
      (gdk.serverParser.rootAssetPath || "") + "sounds/" + soundManager.soundSpriteDef.urls[i]
    );
  }

  // Go through all sounds in config. If there isnt one defined, create a default with the same name as file name for easy access to for the developer
  var keys = Object.keys(soundManager.soundSpriteDef.sprite);
  for (var i = 0; i < keys.length; i++) {
    if (checkForUndefined(soundManager.soundsConfig.tags[keys[i]])) {
      soundManager.soundsConfig.tags[keys[i]] = {
        filename: keys[i],
        loop: soundManager.soundSpriteDef.sprite[keys[i]][2],
      };
    }
  }

  // Set all sounds to not yet played so we can track which we have used
  var keys = Object.keys(soundManager.soundSpriteDef.sprite);
  for (var i = 0; i < keys.length; i++) {
    soundManager.soundsConfig.tags[keys[i]].played = false;
  }

  var howlDef = {
    src: soundManager.soundSpriteDef.urls,
    sprite: soundManager.soundSpriteDef.sprite,
    onloaderror: soundManager.onSoundLoadError,
    onload: soundManager.onSoundLoadComplete,
    onend: soundManager.onSoundEnd,
    onplay: soundManager.onPlay,
  };
  soundManager.soundSprite = new Howl(howlDef);
};

soundManager.getSoundPosition = function (id) {
  if (soundManager.playingSounds.indexOf(id) === -1) {
    console.error("Sound id " + id + " is not playing");
    return 0;
  }

  var position = soundManager.soundSprite.seek(id);
  return position;
};

soundManager.isLooping = function (filename) {
  var keys = Object.keys(soundManager.soundsConfig.tags);
  for (var i = 0; i < keys.length; i++) {
    if (soundManager.soundsConfig.tags[keys[i]].filename === filename) {
      return soundManager.soundsConfig.tags[keys[i]].loop;
    }
  }

  return false;
};

// ----------------
// CALLBACKS
// ----------------

soundManager.onPlay = function (id) {
  if (soundManager.playingSounds.indexOf(id) === -1) {
    // If a sound is pause and resumed, this can fire again
    soundManager.playingSounds.push(id);
  }

  var index = soundManager.delayedStop.indexOf(id);
  if (index !== -1) {
    // This sounds was signalled to stop before it started
    soundManager.delayedStop.splice(index, 1);
    soundManager.soundSprite.stop(id);
    soundManager.onSoundEnd(id);
  }
};

soundManager.onSoundEnd = function (id) {
  var callback = soundManager.endedCallbacks[id];

  if (checkForDefined(callback)) {
    callback();
  }

  // Do we need to delete callback?
  // If the sound is looping, and not stopped, the no we dont.
  for (var i = 0; i < soundManager.soundSprite._sounds.length; i++) {
    if (
      soundManager.soundSprite._sounds[i]._id === id &&
      soundManager.soundSprite._sounds[i]._loop &&
      !soundManager.soundSprite._sounds[i]._ended
    )
      return;
  }

  delete soundManager.endedCallbacks[id];
  var index = soundManager.playingSounds.indexOf(id);
  if (index !== -1) {
    soundManager.playingSounds.splice(index, 1);
    soundManager.getSound(id, true);
  }
};

soundManager.onSoundLoadError = function (ID, errorCode) {
  if (!soundManager.soundLoadingError) {
    console.log("Error loading sound sprite ID " + ID);

    switch (errorCode) {
      case 1:
        console.log("The fetching process for the media resource was aborted by the user agent at the user's request.");
        break;
      case 2:
        console.log(
          "A network error of some description caused the user agent to stop fetching the media resource, after the resource was established to be usable."
        );
        break;
      case 3:
        console.log(
          "An error of some description occurred while decoding the media resource, after the resource was established to be usable."
        );
        break;
      case 4:
        console.log(
          "The media resource indicated by the src attribute or assigned media provider object was not suitable."
        );
        break;
      default:
        console.log("Error - '" + errorCode + "'");
        break;
    }
  }

  soundManager.soundLoadingError = true;

  if (typeof soundManager.progressCallback !== "undefined") {
    soundManager.progressCallback("sounds", {}, {});
    soundManager.progressCallback = undefined;
  }

  if (typeof soundManager.completeCallback !== "undefined") {
    soundManager.completeCallback("sounds", {});
    soundManager.completeCallback = undefined;
  }
};

soundManager.onSoundLoadComplete = function () {
  soundManager.progressCallback("sounds", {}, {});
  soundManager.completeCallback("sounds", {});

  soundManager.progressCallback = undefined;
  soundManager.completeCallback = undefined;
};

// ----------------
// TIMESCALE
// ----------------
soundManager.setTimeScale = function (timeMultiplier) {
  soundManager.timeMultiplier = timeMultiplier;
  if (checkForUndefined(soundManager.soundSprite)) return;

  for (var i = soundManager.soundSprite._sounds.length - 1; i >= 0; i--) {
    if (!soundManager.soundSprite._sounds[i]._ended) {
      soundManager.soundSprite.rate(timeMultiplier, soundManager.soundSprite._sounds[i]._id);
    }
  }
};

soundManager.stateChangeRequested = function (state) {
  soundManager.mute(state.muted);
};

soundManager.tabSwitched = function () {
  if (document.visibilityState === "hidden") {
    soundManager.preHiddenMuteState = soundManager._mute || soundManager._forceMute;
    Howler.mute(true);
  } else {
    Howler.mute(soundManager.preHiddenMuteState);
  }
};

soundManager.isMuted = function () {
  return soundManager._mute || soundManager._forceMute;
};

soundManager.stopAllSounds = function () {
  if (checkForUndefined(soundManager.soundSprite)) return;

  // 1st, stop any tweens currently active
  if (Array.isArray(soundManager.allSounds) === true) {
    for (let i = 0; i < soundManager.allSounds.length; i++) {
      const timer = soundManager.allSounds[i].timer;
      if (timer) {
        timer.kill();
      }
    }
  }

  for (let i = 0; i < soundManager.soundSprite._sounds.length; i++) {
    soundManager.stop(soundManager.soundSprite._sounds[i]._id);
  }
};

messageBus.subscribe("audio:stateChanged", soundManager.stateChangeRequested);

if (Reflex.masterGame === true) {
  document.addEventListener("visibilitychange", soundManager.tabSwitched, false);
} else {
  Howler = window.parent.Howler;
  soundManager = window.parent.soundManager;
  soundManager.sharedMode = true;
  soundManager.stopAllSounds();
  soundManager.mute(false);
}
